export class FieldConfig {
    constructor(key, label, placeholder = "", priority = 1, type = 'input', visibility = '', IsVisible = false,
      //  PagePermission = 'disable'
      //  ,
      place = '', value = "") {
      this.key = key;
      this.label = label;
      this.placeholder = placeholder;
      this.priority = priority;
      this.type = type;
      this.visibility = visibility;
      this.IsVisible = IsVisible;
      // this.PagePermission = PagePermission;
      this.place = place;
      this.value = value;
  
    }
  
    // Method to update visibility based on API response
    setVisibility(isVisible) {
      this.isVisible = isVisible;
    }
  }
  
  
  
  export const DiamondPopUpFields = [
  
    // new FieldConfig("DiamondName", "Diamond Name", "", 1, "inputselect", "ReadWrite", true, "top"),
    new FieldConfig("DiamondShape", "Diamond Shape", "", 1, "dropdown", "ReadWrite", true, "top"),
    new FieldConfig("DiamondClarity", "Diamond Clarity", "", 1, "dropdown", "ReadWrite", true, "top"),
    new FieldConfig("DiamondColour", "Diamond Colour", "", 1, "dropdown", "ReadWrite", true, "top"),
    new FieldConfig("DiamondSleve", "Diamond Sleve", "", 1, "text", "ReadWrite", true, "top"),
    new FieldConfig("DiamondSize", "Diamond Size", "", 1, "text", "ReadWrite", true, "top"),
    new FieldConfig("DiamondWeight", "Diamond Weight", "", 1, "number", "ReadWrite", true, "top"),
    new FieldConfig("DiamondRate", "Diamond Rate", "", 1, "number", "ReadWrite", true, "top"),
    new FieldConfig("DiamondAmount", "Amount", "", 1, "number", "ReadWrite", true, "top"),
    new FieldConfig("DiamondCut", "Diamond Cut", "", 1, "number", "ReadWrite", true, "top"),
    new FieldConfig("DiamondSettingType", "Setting Type", "", 1, "number", "ReadWrite", true, "top"),
    new FieldConfig("DiamondCertificate", "Certificate", "", 1, "number", "ReadWrite", true, "top"),
    new FieldConfig("DiamondDescription", "Description", "", 1, "number", "ReadWrite", true, "top"),
  
   
  
  ];